import {all, call, fork, put} from "redux-saga/effects";
import {apiClient} from 'util/Api'
import {
    ADD_BR_BUSINESS_SHARE,
    ADD_BR_DOMAIN_PROVIDED,
    ADD_BR_PORTFOLIO_ENTITY,
    ADD_BR_PORTFOLIO_REPORT_REQUEST,
    ADD_BR_SUBDOMAIN_PROVIDED,
    ADD_BR_TARGETIP_PROVIDED,
    ADD_BR_VALIDATION,
    DELETE_BR_PORTFOLIO_ENTITY,
    FETCH_BR_BUSINESS_SHARES,
    FETCH_CYCLE_REPORT,
    FETCH_CYCLE_DETAILS,
    FETCH_CYCLE_TARGETS,
    FETCH_PORTFOLIO,
    UPDATE_BR_ATTACKS_AUTHORIZED,
    UPDATE_BR_BUSINESS_SHARE,
    UPDATE_BR_DOMAIN_PROVIDED,
    UPDATE_BR_SUBDOMAIN_PROVIDED,
    UPDATE_BR_TARGETIP_PROVIDED,
    FETCH_CYCLE,
    CLOUD_INTEGRATION_GET_OPTIONS,
    CLOUD_INTEGRATION_REGISTER,
    CLOUD_INTEGRATION_UNREGISTER,
    FETCH_TARGET_DETAILS,
    FETCH_CYCLE_SOCIAL,
    FETCH_IDENTITY_DETAILS,
    UPDATE_BR_SOCIAL_TESTS_AUTHORIZED,
    ADD_BR_IDENTITY_PROVIDED,
    UPDATE_BR_IDENTITY_PROVIDED,
    FETCH_CLOUD_INTEGRATION_DATA,
    FETCH_VECTOR_RESULTS,
    ADD_BR_SUBPORTFOLIO,
    ADD_BR_NEW_ENTITY_TO_SUBPORTFOLIO,
    DELETE_BR_SUBPORTFOLIO,
    UPDATE_BR_SUBPORTFOLIO,
    FETCH_CLOUD_INTEGRATION_FILES,
    VERIFY_PRIMARY_DOMAIN, UPDATE_ENTITY_NAME,
} from "constants/ActionTypes";

import {takeEvery, takeLeading} from "@redux-saga/core/effects";
import {bbStandardRequestHandler} from "../util/bbHelpers";
import {
    addBRBusinessShareFail,
    addBRBusinessShareSuccess,
    addBRDomainProvidedFail,
    addBRDomainProvidedSuccess,
    addBRPortfolioEntity,
    addBRPortfolioEntityFail,
    addBRPortfolioEntitySuccess,
    addBRPortfolioReportRequestFail,
    addBRPortfolioReportRequestSuccess,
    addBRSubdomainProvidedFail,
    addBRSubdomainProvidedSuccess,
    addBRTargetIpProvidedFail,
    addBRTargetIpProvidedSuccess,
    addBRValidationFail,
    addBRValidationSuccess,
    fetchBRBusinessSharesFail,
    fetchBRBusinessSharesSuccess,
    fetchRiskCycleDetailsFail,
    fetchRiskCycleDetailsSuccess,
    fetchRiskCycleReportFail,
    fetchRiskCycleReportSuccess,
    fetchRiskCycleTargetsFail,
    fetchRiskCycleTargetsSuccess,
    fetchRiskPortfolioFail,
    fetchRiskPortfolioSuccess,
    updateBRAttacksAuthorizedFail,
    updateBRAttacksAuthorizedSuccess,
    updateBRBusinessShareFail,
    updateBRBusinessShareSuccess,
    updateBRDomainProvidedFail,
    updateBRDomainProvidedSuccess,
    updateBRSubdomainProvidedFail,
    updateBRSubdomainProvidedSuccess,
    updateBRTargetIpProvidedFail,
    updateBRTargetIpProvidedSuccess,
    fetchRiskCycleFail,
    fetchRiskCycleSuccess,
    fetchCloudIntegrationOptionsFail,
    fetchCloudIntegrationOptionsSuccess,
    registerCloudIntegrationSuccess,
    registerCloudIntegrationFail,
    unregisterCloudIntegrationSuccess,
    unregisterCloudIntegrationFail,
    fetchTargetDetailsSuccess,
    fetchTargetDetailsFail,
    fetchCycleSocialSuccess,
    fetchCycleSocialFail,
    fetchIdentityDetailsSuccess,
    fetchIdentityDetailsFail,
    updateBRSocialTestsAuthorizedSuccess,
    updateBRSocialTestsAuthorizedFail,
    addBRIdentityProvidedSuccess,
    addBRIdentityProvidedFail,
    updateBRIdentityProvidedSuccess,
    updateBRIdentityProvidedFail,
    deleteBRPortfolioEntityFail,
    deleteBRPortfolioEntitySuccess,
    fetchCloudIntegrationDataSuccess,
    fetchCloudIntegrationDataFail,
    fetchVectorResultsSuccess,
    fetchVectorResultsFail,
    addSubportfolioSuccess,
    addSubportfolioFail,
    deleteSubportfolioSuccess,
    deleteSubportfolioFail,
    updateSubportfolioSuccess,
    updateSubportfolioFail,
    addBRPortfolioEntityAndAddToSubportfolioSuccess,
    addBRPortfolioEntityAndAddToSubportfolioFail,
    fetchCloudIntegrationFilesSuccess,
    fetchCloudIntegrationFilesFail,
    verifyPrimaryDomainSuccess,
    verifyPrimaryDomainFailure, verifyPrimaryDomainFail, updateEntityNameSuccess, updateEntityNameFail,
} from "../actions";
import {bbDeviantRequestHandler} from "../util/TestDeviantRequestHandlerFunction";


/* ***************************
   Fetching risk portfolios
   *************************** */

const getRiskPortfolioRequest = async (customerId) =>
    await  apiClient.get(`/risk/portfolio?customer=${customerId}`, {timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* getRiskPortfolioGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "fetchRiskPortfolio";     console.group(`${standardName} Generator...: `);
    const {customerId} = payload;
    const request = yield call(getRiskPortfolioRequest, customerId);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, false, true);

    if (didRequestSucceed) {
        yield put(fetchRiskPortfolioSuccess(
            {
                customerId: customerId,
                inboundData: request.data,
            }));
    } else {
        yield put(fetchRiskPortfolioFail({
            customerId: customerId,
            request: request.data,
        }));
    }

    console.groupEnd();
}

export function* watchLeadingGetRiskPortfolioGenerator() {
    yield takeLeading(FETCH_PORTFOLIO, getRiskPortfolioGenerator);
}

/* ***************************
   Fetching a risk cycle REPORT
   *************************** */

const getRiskCycleReportRequest = async (cycleId) =>
    await  apiClient.get(`/risk/cycle/report?cycle=${cycleId}`, {timeout: 60000}
    )
        .then(data => data)
        .catch(error => error);

function* getRiskCycleReportGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "fetchRiskCycleReport";     console.group(`${standardName} Generator...: `);
    const {cycleId, customerId} = payload;
    const request = yield call(getRiskCycleReportRequest, cycleId);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, false, true);

    if (didRequestSucceed) {
        yield put(fetchRiskCycleReportSuccess(
            {
                customerId: customerId,
                cycleId: cycleId,
                inboundData: request.data,
            }));
    } else {
        yield put(fetchRiskCycleReportFail({
            cycleId: cycleId,
            request: request.data,
        }));
    }

    console.groupEnd();
}

export function* watchLeadingGetRiskCycleReportGenerator() {
    yield takeLeading(FETCH_CYCLE_REPORT, getRiskCycleReportGenerator);
}

/* ***************************
   Fetching a risk cycle details (technical data)
   *************************** */

const getRiskCycleDetailsRequest = async (cycleId, pageNum) =>
    await  apiClient.get(`/risk/cycle/details?cycle=${cycleId}${pageNum && `&page=${pageNum}`}`, {timeout: 100000}
    )
        .then(data => data)
        .catch(error => error);

function* getRiskCycleDetailsGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "fetchRiskCycleDetails";     console.group(`${standardName} Generator...: `);
    const {cycleId, customerId, pageNum = null} = payload;
    const request = yield call(getRiskCycleDetailsRequest, cycleId, pageNum);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, false, true);

    if (didRequestSucceed) {
        yield put(fetchRiskCycleDetailsSuccess(
            {
                customerId: customerId,
                cycleId: cycleId,
                pageNumberFetched: pageNum,
                inboundData: request.data,
            }));
    } else {
        yield put(fetchRiskCycleDetailsFail({
            cycleId: cycleId,
            request: request.data,
        }));
    }

    console.groupEnd();
}

export function* watchLeadingGetRiskCycleDetailsGenerator() {
    yield takeLeading(FETCH_CYCLE_DETAILS, getRiskCycleDetailsGenerator);
}

/* ***************************
   Fetching a BR Business entities' shares
   *************************** */

const getBRBusinessSharesRequest = async () =>
    await  apiClient.get(`/risk/share`, {timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* getBRBusinessSharesGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "fetchBRBusinessShares";     console.group(`${standardName} Generator...: `);
    const {customerId} = payload;
    const request = yield call(getBRBusinessSharesRequest,);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, false, true);

    if (didRequestSucceed) {
        yield put(fetchBRBusinessSharesSuccess(
            {
                customerId: customerId,
                // entityId: entityId,
                inboundData: request.data,
            }));
    } else {
        yield put(fetchBRBusinessSharesFail({
            // entityId: entityId,
            request: request.data,
        }));
    }

    console.groupEnd();
}

export function* watchLeadingGetBRBusinessSharesGenerator() {
    yield takeLeading(FETCH_BR_BUSINESS_SHARES, getBRBusinessSharesGenerator);
}

/* ***************************
   Adding a BR Business entities' shares
   *************************** */

const postBRBusinessShareRequest = async (companyName, firstName, lastName, email, entityId, comments, dataLevel) =>
    await  apiClient.post(`/risk/share`,{
        company_name: companyName,
        first_name: firstName,
        last_name: lastName,
        email: email,
        comments: comments,
        entity: entityId,
        data_level: dataLevel
        },{timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* postBRBusinessShareGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "addBRBusinessShare";     console.group(`${standardName} Generator...: `);
    const {companyName, firstName, lastName, email, entityId, comments, customerId, dataLevel} = payload;
    const request = yield call(postBRBusinessShareRequest, companyName, firstName, lastName, email, entityId, comments, dataLevel);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true);

    if (didRequestSucceed) {
        yield put(addBRBusinessShareSuccess(
            {
                customerId: customerId,
                entityId: entityId,
                inboundData: request.data,
            }));
    } else {
        yield put(addBRBusinessShareFail({
            entityId: entityId,
            request: request.data,
        }));
    }

    console.groupEnd();
}

export function* watchLeadingPostBRBusinessShareGenerator() {
    yield takeLeading(ADD_BR_BUSINESS_SHARE, postBRBusinessShareGenerator);
}


/* ***************************
   Disabling a BR Business entities' shares
   *************************** */

const putBRBusinessShareRequest = async (shareId, property, newStatus, newLevel) =>
    await  apiClient.put(`/risk/share`,{
            id: shareId,
            [`${property}`]: property === "data_level" ? newLevel : newStatus ? 1 : 0
        },{timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* putBRBusinessShareGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "updateBRBusinessShare";     console.group(`${standardName} Generator...: `);
    const {shareId, property, newStatus, customerId, newLevel} = payload;
    const request = yield call(putBRBusinessShareRequest, shareId, property, newStatus, newLevel);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true);

    if (didRequestSucceed) {
        yield put(updateBRBusinessShareSuccess(
            {
                customerId: customerId,
                shareId: shareId,
                inboundData: request.data,
            }));
    } else {
        yield put(updateBRBusinessShareFail({
            shareId: shareId,
            request: request.data,
        }));
    }

    console.groupEnd();
}

export function* watchEveryPutBRBusinessShareGenerator() {
    yield takeEvery(UPDATE_BR_BUSINESS_SHARE, putBRBusinessShareGenerator);
}

/* ***************************
   Updating a BR Business entities' shares' access level
   *************************** */

// const putBRBusinessShareAccessLevelRequest = async (shareId, newLevel) =>
//     await  apiClient.put(`/risk/share`,{
//             id: shareId,
//             data_level: newLevel,
//         },{timeout: 25000}
//     )
//         .then(data => data)
//         .catch(error => error);
//
// function* putBRBusinessShareAccessLevelGenerator({payload}) {
//     /*  jfd*******************************
//      *   Modify these parameters and the fail and success cases below
//          ********************************** */
//     const standardName = "updateBRBusinessAccessLevelShare";     console.group(`${standardName} Generator...: `);
//     const {shareId, newLevel, customerId} = payload;
//     const request = yield call(putBRBusinessShareAccessLevelRequest, shareId, newLevel);
//     /*  ******END*******************/
//
//     const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true);
//
//     if (didRequestSucceed) {
//         yield put(updateBRBusinessShareAccessLevelSuccess(
//             {
//                 customerId: customerId,
//                 shareId: shareId,
//                 inboundData: request.data,
//             }));
//     } else {
//         yield put(updateBRBusinessShareAccessLevelFail({
//             shareId: shareId,
//             request: request.data,
//         }));
//     }
//
//     console.groupEnd();
// }
//
// export function* watchEveryPutBRBusinessShareAccessLevelGenerator() {
//     yield takeEvery(UPDATE_BR_BUSINESS_SHARE_ACCESS_LEVEL, putBRBusinessShareAccesLevelGenerator);
// }

/* ***************************
   Adding a BR PORTFOLIO entity
   *************************** */

const postBRPortfolioEntityRequest = async (organizationName, website, customerId) =>
    await  apiClient.post(`/risk/portfolio`,{
            name: organizationName,
            website: website,
            customer: customerId
        },{timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* postBRPortfolioEntityGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "addBRPortfolioEntity";     console.group(`${standardName} Generator...: `);
    const {organizationName, website, customerId} = payload;
    const request = yield call(postBRPortfolioEntityRequest, organizationName, website, customerId);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true);

    if (didRequestSucceed) {
        yield put(addBRPortfolioEntitySuccess(
            {
                customerId: customerId,
                // entityId: entityId,
                inboundData: request.data,
            }));
    } else {
        yield put(addBRPortfolioEntityFail({
            // entityId: entityId,
            customerId: customerId,
            request: request.data,
        }));
    }

    console.groupEnd();
}

export function* watchLeadingPostBRPortfolioEntityGenerator() {
    yield takeLeading(ADD_BR_PORTFOLIO_ENTITY, postBRPortfolioEntityGenerator);
}

/* ***************************
   Deleting a BR PORTFOLIO entity
   *************************** */

const deleteBRPortfolioEntityRequest = async (entityId, customerId) =>
    await  apiClient.delete(`/risk/portfolio`,
        { data: {
                entity: entityId,
                customer: customerId
            }
        },{timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* deleteBRPortfolioEntityGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "deleteBRPortfolioEntity";     console.group(`${standardName} Generator...: `);
    const {entityId, customerId} = payload;
    const request = yield call(deleteBRPortfolioEntityRequest, entityId, customerId);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true);

    if (didRequestSucceed) {
        yield put(deleteBRPortfolioEntitySuccess (
            {
                customerId: customerId,
                // entityId: entityId,
                inboundData: request.data,
            }));
    } else {
        yield put(deleteBRPortfolioEntityFail({
            // entityId: entityId,
            customerId: customerId,
            request: request.data,
        }));
    }

    console.groupEnd();
}

export function* watchLeadingDeleteBRPortfolioEntityGenerator() {
    yield takeLeading(DELETE_BR_PORTFOLIO_ENTITY, deleteBRPortfolioEntityGenerator);
}

/* ***************************
   Adding a BR PORTFOLIO report request
   *************************** */

const postBRPortfolioReportRequestRequest = async (customerId, entityId, pocFName, pocLName, pocEmail, dataLevel) =>
    await  apiClient.post(`/risk/portfolio/request`,{
            customer: customerId,
            entity: entityId,
            request_poc_first: pocFName,
            request_poc_last: pocLName,
            request_poc_email: pocEmail,
            data_level: dataLevel,
            request_level: 7
        },{timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* postBRPortfolioReportRequestGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "addBRPortfolioReportRequest";     console.group(`${standardName} Generator...: `);
    const {customerId, entityId, pocFName, pocLName, pocEmail, dataLevel} = payload;
    const request = yield call(postBRPortfolioReportRequestRequest, customerId, entityId, pocFName, pocLName, pocEmail, dataLevel);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true);

    if (didRequestSucceed) {
        yield put(addBRPortfolioReportRequestSuccess(
            {
                customerId: customerId,
                // entityId: entityId,
                inboundData: request.data,
            }));
    } else {
        yield put(addBRPortfolioReportRequestFail({
            // entityId: entityId,
            customerId: customerId,
            request: request.data,
        }));
    }

    console.groupEnd();
}

export function* watchLeadingPostBRPortfolioReportRequestGenerator() {
    yield takeLeading(ADD_BR_PORTFOLIO_REPORT_REQUEST, postBRPortfolioReportRequestGenerator);
}


/* ***************************
   Updating attacks authorized for BR Business customers
   *************************** */

const putBRAttacksAuthorizedRequest = async (entityId, newAuthorizeStatus) =>
    await  apiClient.put(`/risk/entity/authorize`,{
            entity: entityId,
            authorize: newAuthorizeStatus
        },{timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* putBRAttacksAuthorizedGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "updateBRAttacksAuthorized";     console.group(`${standardName} Generator...: `);
    const {customerId, entityId, newAuthorizeStatus} = payload;
    const request = yield call(putBRAttacksAuthorizedRequest, entityId, newAuthorizeStatus);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true);

    if (didRequestSucceed) {
        yield put(updateBRAttacksAuthorizedSuccess(
            {
                customerId: customerId,
                entityId: entityId,
                inboundData: request.data,
            }));
    } else {
        yield put(updateBRAttacksAuthorizedFail({
            entityId: entityId,
            request: request.data,
        }));
    }

    console.groupEnd();
}

export function* watchLeadingPutBRAttacksAuthorizedGenerator() {
    yield takeLeading(UPDATE_BR_ATTACKS_AUTHORIZED, putBRAttacksAuthorizedGenerator);
}

/* ***************************
   Adding a Target Provided
   *************************** */

const postBRTargetIpProvidedRequest = async (entityId, ip, comments) =>
    await  apiClient.post(`/risk/target/provided`,{
            entity: entityId,
            ip: ip,
            comments: comments ? comments : null,
        },{timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* postBRTargetIpProvidedGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "addBRTargetIpProvided";     console.group(`${standardName} Generator...: `);
    const {customerId, entityId, ip, comments} = payload;
    const request = yield call(postBRTargetIpProvidedRequest, entityId, ip, comments);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true);

    if (didRequestSucceed) {
        yield put(addBRTargetIpProvidedSuccess(
            {
                customerId: customerId,
                entityId: entityId,
                inboundData: request.data,
            }));
    } else {
        yield put(addBRTargetIpProvidedFail({
            entityId: entityId,
            request: request.data,
        }));
    }

    console.groupEnd();
}

export function* watchLeadingPostBRTargetIpProvidedGenerator() {
    yield takeLeading(ADD_BR_TARGETIP_PROVIDED, postBRTargetIpProvidedGenerator);
}

/* ***************************
   Updating TARGET IPs Provided
   *************************** */

const putBRTargetIpProvidedRequest = async (targetId, newIsActiveStatus) =>
    await  apiClient.put(`/risk/target/provided`,{
            id: targetId,
            is_active: newIsActiveStatus,
        },{timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* putBRTargetIpProvidedGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "updateBRTargetIpProvided";     console.group(`${standardName} Generator...: `);
    const {customerId, entityId, targetId, newIsActiveStatus} = payload;
    const request = yield call(putBRTargetIpProvidedRequest, targetId, newIsActiveStatus);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true);

    if (didRequestSucceed) {
        yield put(updateBRTargetIpProvidedSuccess(
            {
                customerId: customerId,
                entityId: entityId,
                inboundData: request.data,
            }));
    } else {
        yield put(updateBRTargetIpProvidedFail({
            entityId: entityId,
            request: request.data,
        }));
    }

    console.groupEnd();
}

export function* watchLeadingPutBRTargetIpProvidedGenerator() {
    yield takeLeading(UPDATE_BR_TARGETIP_PROVIDED, putBRTargetIpProvidedGenerator);
}

/* ***************************
   Adding a BR Domain Provided
   *************************** */

const postBRDomainProvidedRequest = async (entityId, domain, comments) =>
    await  apiClient.post(`/risk/domain`,{
            entity: entityId,
            domain: domain,
            comments: comments ? comments : null
        },{timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* postBRDomainProvidedGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "addBRDomainProvided";     console.group(`${standardName} Generator...: `);
    const {customerId, entityId, domain, comments} = payload;
    const request = yield call(postBRDomainProvidedRequest, entityId, domain, comments);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true);

    if (didRequestSucceed) {
        yield put(addBRDomainProvidedSuccess(
            {
                customerId: customerId,
                entityId: entityId,
                inboundData: request.data,
            }));
    } else {
        yield put(addBRDomainProvidedFail({
            entityId: entityId,
            request: request.data,
        }));
    }

    console.groupEnd();
}

export function* watchLeadingPostBRDomainProvidedGenerator() {
    yield takeLeading(ADD_BR_DOMAIN_PROVIDED, postBRDomainProvidedGenerator);
}

/* ***************************
   Updating a Domain provided
   *************************** */

const putBRDomainProvidedRequest = async (domainId, newIsActiveStatus, newComments) =>
    await  apiClient.put(`/risk/domain`,{
            id: domainId,
            is_active: newIsActiveStatus,
            comments : newComments,
        },{timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* putBRDomainProvidedGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "updateBRDomainProvided";     console.group(`${standardName} Generator...: `);
    const {customerId, entityId, domainId, newIsActiveStatus, newComments} = payload;
    const request = yield call(putBRDomainProvidedRequest, domainId, newIsActiveStatus, newComments);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true);

    if (didRequestSucceed) {
        yield put(updateBRDomainProvidedSuccess(
            {
                customerId: customerId,
                entityId: entityId,
                inboundData: request.data,
            }));
    } else {
        yield put(updateBRDomainProvidedFail({
            customerId: customerId,
            entityId: entityId,
            request: request.data,
        }));
    }

    console.groupEnd();
}

export function* watchLeadingPutBRDomainProvidedGenerator() {
    yield takeLeading(UPDATE_BR_DOMAIN_PROVIDED, putBRDomainProvidedGenerator);
}


/* ***************************
   Adding a BR Subdomain Provided
   *************************** */

const postBRSubdomainProvidedRequest = async (entityId, subdomain, domainId, comments) =>
    await  apiClient.post(`/risk/subdomain/provided`,{
            entity: entityId,
            domain: domainId,
            subdomain: subdomain,
            comments: comments ? comments : null
        },{timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* postBRSubdomainProvidedGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "addBRSubdomainProvided";     console.group(`${standardName} Generator...: `);
    const {customerId, entityId, subdomain, domainId, comments} = payload;
    const request = yield call(postBRSubdomainProvidedRequest, entityId, subdomain, domainId, comments);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true);

    if (didRequestSucceed) {
        yield put(addBRSubdomainProvidedSuccess(
            {
                customerId: customerId,
                entityId: entityId,
                inboundData: request.data,
            }));
    } else {
        yield put(addBRSubdomainProvidedFail({
            entityId: entityId,
            request: request.data,
        }));
    }

    console.groupEnd();
}

export function* watchLeadingPostBRSubdomainProvidedGenerator() {
    yield takeLeading(ADD_BR_SUBDOMAIN_PROVIDED, postBRSubdomainProvidedGenerator);
}

/* ***************************
   Updating Subodomains provided
   *************************** */

const putBRSubdomainProvidedRequest = async (subdomainId, newIsActiveStatus, newComments) =>
    await  apiClient.put(`/risk/subdomain/provided`,{
            id: subdomainId,
            is_active: newIsActiveStatus,
            comments : newComments,
        },{timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* putBRSubdomainProvidedGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "updateBRSubdomainProvided";     console.group(`${standardName} Generator...: `);
    const {customerId, entityId, subdomainId, newIsActiveStatus, newComments} = payload;
    const request = yield call(putBRSubdomainProvidedRequest, subdomainId, newIsActiveStatus, newComments);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true);

    if (didRequestSucceed) {
        yield put(updateBRSubdomainProvidedSuccess(
            {
                customerId: customerId,
                entityId: entityId,
                inboundData: request.data,
            }));
    } else {
        yield put(updateBRSubdomainProvidedFail({
            entityId: entityId,
            request: request.data,
        }));
    }

    console.groupEnd();
}

export function* watchLeadingPutBRSubdomainProvidedGenerator() {
    yield takeLeading(UPDATE_BR_SUBDOMAIN_PROVIDED, putBRSubdomainProvidedGenerator);
}

/* ***************************
   Adding a BR Validation record
   *************************** */

const postBRValidationRequest = async (entityId, isValidated, comments) =>
    await  apiClient.post(`/risk/entity/validate`,{
            entity: entityId,
            validated: isValidated,
            comments: comments ? comments : null
        },{timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* postBRValidationGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "addBRValidation";     console.group(`${standardName} Generator...: `);
    const {customerId, entityId, isValidated, comments} = payload;
    const request = yield call(postBRValidationRequest, entityId, isValidated, comments);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true);

    if (didRequestSucceed) {
        yield put(addBRValidationSuccess(
            {
                customerId: customerId,
                entityId: entityId,
                inboundData: request.data,
            }));
    } else {
        yield put(addBRValidationFail({
            entityId: entityId,
            request: request.data,
        }));
    }

    console.groupEnd();
}

export function* watchLeadingPostBRValidationGenerator() {
    yield takeLeading(ADD_BR_VALIDATION, postBRValidationGenerator);
}

// /* ***************************
//    Adding a Tag
//    *************************** */
//
// const postTagRequest = async (
//         {
//             definitionId,
//             entityId,
//             targetId,
//             vectorId,
//             testedVectorId,
//             identityId,
//             details,
//             userId,
//             customerId,
//         }
//     ) =>
//     await  apiClient.post(`/risk/tag`,{
//         definition: definitionId,
//         entity: entityId ? entityId : null,
//         target: targetId ? targetId : null,
//         vector: vectorId ? vectorId : null,
//         tested_vector: testedVectorId ? testedVectorId : null,
//         identity: identityId ? identityId : null,
//         details: details ? details : null,
//         user: userId ? userId : null,
//         customer: customerId ? customerId : null,
//         },{timeout: 25000}
//     )
//         .then(data => data)
//         .catch(error => error);
//
// function* postTagGenerator({payload}) {
//     /*  jfd*******************************
//      *   Modify these parameters and the fail and success cases below
//          ********************************** */
//     const standardName = "addTag";     console.group(`${standardName} Generator...: `);
//     const {
//         definitionId,
//         entityId,
//         targetId,
//         vectorId,
//         testedVectorId,
//         identityId,
//         details,
//         userId,
//         customerId,
//         showUserMessage,
//         affectedElementId,
//         successAction = (data) => null,
//         failAction = (data) => null
//     } = payload;
//     const request = yield call(postTagRequest,
//         {
//             definitionId,
//             entityId,
//             targetId,
//             vectorId,
//             testedVectorId,
//             identityId,
//             details,
//             userId,
//             customerId,
//         },
//     );
//     /*  ******END*******************/
//
//     const didRequestSucceed = bbStandardRequestHandler(request, standardName, showUserMessage, true);
//
//     //archiving generic way of calling ther reducer
//     // if (didRequestSucceed) {
//     //     yield put(addTagSuccess(
//     //         {
//     //             customerId: customerId,
//     //             affectedElementId: affectedElementId,
//     //             inboundData: request.data,
//     //         }));
//     // } else {
//     //     yield put(addTagFail({
//     //         affectedElementId: affectedElementId,
//     //         request: request.data,
//     //     }));
//     // }
//
//     if (didRequestSucceed) {
//         yield put(successAction(
//             {
//                 customerId: customerId,
//                 affectedElementId: affectedElementId,
//                 inboundData: request.data,
//             }));
//     } else {
//         yield put(failAction({
//             affectedElementId: affectedElementId,
//             request: request.data,
//         }));
//     }
//
//     console.groupEnd();
// }
//
// export function* watchLeadingPostTagGenerator() {
//     yield takeLeading(ADD_TAG, postTagGenerator);
// }
//
// /* ***************************
//    updateing a Tag
//    *************************** */
//
// const putTagRequest = async (tagId, newIsActive) =>
//     await  apiClient.put(`/risk/tag`,{
//             id: tagId,
//             is_active: newIsActive,
//         },{timeout: 25000}
//     )
//         .then(data => data)
//         .catch(error => error);
//
// function* putTagGenerator({payload}) {
//     /*  jfd*******************************
//      *   Modify these parameters and the fail and success cases below
//          ********************************** */
//     const standardName = "updateTag";     console.group(`${standardName} Generator...: `);
//     const {customerId, affectedElementId, tagId, newIsActive} = payload;
//     const request = yield call(putTagRequest, tagId, newIsActive);
//     /*  ******END*******************/
//
//     const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true);
//
//     if (didRequestSucceed) {
//         yield put(updateTagSuccess(
//             {
//                 customerId,
//                 affectedElementId,
//                 tagId: tagId,
//                 inboundData: request.data,
//             }));
//     } else {
//         yield put(updateTagFail({
//             customerId,
//             affectedElementId,
//             tagId: tagId,
//             request: request.data,
//         }));
//     }
//
//     console.groupEnd();
// }
//
// export function* watchLeadingPutTagGenerator() {
//     yield takeLeading(UPDATE_TAG, putTagGenerator);
// }


/* ***************************
   Fetching a risk cycle TARGETS (IPs)
   *************************** */

const getRiskCycleTargetsRequest = async (cycleId, pageNum = 1) =>
    await  apiClient.get(`/risk/cycle/targets?cycle=${cycleId}&page=${pageNum}`, {timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* getRiskCycleTargetsGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "fetchRiskCycleTargets";     console.group(`${standardName} Generator...: `);
    const {cycleId, entityId, pageNum, customerId} = payload;
    const request = yield call(getRiskCycleTargetsRequest, cycleId, pageNum);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, false, true);

    if (didRequestSucceed) {
        yield put(fetchRiskCycleTargetsSuccess(
            {
                customerId: customerId,
                assumedEntityId: entityId,
                cycleId: cycleId,
                pageNum: pageNum,
                inboundData: request.data,
            }));
    } else {
        yield put(fetchRiskCycleTargetsFail({
            cycleId: cycleId,
            assumedEntityId: entityId,
            pageNum: pageNum,
            request: request.data,
        }));
    }

    console.groupEnd();
}

export function* watchLeadingGetRiskCycleTargetsGenerator() {
    yield takeLeading(FETCH_CYCLE_TARGETS, getRiskCycleTargetsGenerator);
}


/* ***************************
   Fetching a risk cycle
   *************************** */

const getRiskCycleRequest = async (cycleId) =>
    await  apiClient.get(`/risk/cycle?id=${cycleId}`, {timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* getRiskCycleGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "fetchRiskCycle";     console.group(`${standardName} Generator...: `);
    const {cycleId, customerId} = payload;
    const request = yield call(getRiskCycleRequest, cycleId);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, false, true);

    if (didRequestSucceed) {
        yield put(fetchRiskCycleSuccess(
            {
                customerId: customerId,
                cycleId: cycleId,
                inboundData: request.data,
            }));
    } else {
        yield put(fetchRiskCycleFail({
            cycleId: cycleId,
            request: request.data,
        }));
    }

    console.groupEnd();
}

export function* watchLeadingGetRiskCycleGenerator() {
    yield takeEvery(FETCH_CYCLE, getRiskCycleGenerator);
}

/* ***************************
   CLOUD INTEGRATIONS: getting options
   *************************** */

const getCloudIntegrationOptionsRequest = async (entityId) =>
    await  apiClient.get(`/integration${entityId && `?entity=${entityId}`}`, {timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* getCloudIntegrationOptionsGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "fetchCloudIntegrationOptions";     console.group(`${standardName} Generator...: `);
    const {entityId} = payload;
    const request = yield call(getCloudIntegrationOptionsRequest, entityId);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, false, true);

    if (didRequestSucceed) {
        yield put(fetchCloudIntegrationOptionsSuccess(
            {
                entityId,
                inboundData: request.data,
            }));
    } else {
        yield put(fetchCloudIntegrationOptionsFail({
            entityId,
            request: request.data,
        }));
    }

    console.groupEnd();
}

export function* watchLeadingGetCloudIntegrationOptionsGenerator() {
    yield takeLeading(CLOUD_INTEGRATION_GET_OPTIONS, getCloudIntegrationOptionsGenerator);
}


/* ***************************
   CLOUD INTEGRATIONS: Registration step 
   *************************** */

const registerCloudIntegrationRequest = async (entityId,  typeId, description, roleArn, tenentId, appId, clientSecret) =>
    await  apiClient.post(`/integration`,{
            entity: entityId,
            type: typeId,
            description: description,
            role_arn: roleArn,
            tenent_id: tenentId,
            app_id: appId,
            client_secret: clientSecret,
        },{timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* registerCloudIntegrationGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const {entityId, typeId, description, roleArn, tenentId, appId, clientSecret} = payload;
    const standardName = `registerCloudIntegration.${typeId}`;     console.group(`${standardName} Generator...: `);
    const request = yield call(registerCloudIntegrationRequest, entityId,  typeId, description, roleArn, tenentId, appId, clientSecret);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true);

    if (didRequestSucceed) {
        yield put(registerCloudIntegrationSuccess(
            {
                entityId,
                inboundData: request.data,
            }));
    } else {
        yield put(registerCloudIntegrationFail({
            entityId,
            request: request.data,
        }));
    }

    console.groupEnd();
}

export function* watchLeadingGetCloudIntegrationRegistrationGenerator() {
    yield takeLeading(CLOUD_INTEGRATION_REGISTER, registerCloudIntegrationGenerator);
}

/* ***************************
   CLOUD INTEGRATIONS: Registration step 
   *************************** */

const unregisterCloudIntegrationRequest = async (integrationId, description) =>
    await  apiClient.delete(`/integration`,{
            data: {
                id: integrationId,
                details: description,
            }
        },{timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* unregisterCloudIntegrationGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "unregisterCloudIntegration";     console.group(`${standardName} Generator...: `);
    const {integrationId, description} = payload;
    const request = yield call(unregisterCloudIntegrationRequest, integrationId,  description);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true);

    if (didRequestSucceed) {
        yield put(unregisterCloudIntegrationSuccess(
            {
                integrationId,
                inboundData: request.data,
            }));
    } else {
        yield put(unregisterCloudIntegrationFail({
            integrationId,
            request: request.data,
        }));
    }

    console.groupEnd();
}

export function* watchLeadingGetCloudIntegrationUnregistrationGenerator() {
    yield takeLeading(CLOUD_INTEGRATION_UNREGISTER, unregisterCloudIntegrationGenerator);
}

/* ***************************
   CLOUD INTEGRATIONS: fetching data from registered integrations
   *************************** */

const getCloudIntegrationDataRequest = async (entityId, integrationId, queryType, integrationDescription) =>
    await  apiClient.get(`/integration/action?id=${integrationId && integrationId}&query=${queryType && queryType}`, {timeout: 100000}
    )
        .then(data => data)
        .catch(error => error);

function* getCloudIntegrationDataGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const {entityId, integrationId, queryType, integrationDescription } = payload;
    const standardName = `fetchCloudIntegrationData.${queryType}`;     console.group(`${standardName} Generator...: `);
    const request = yield call(getCloudIntegrationDataRequest, entityId, integrationId, queryType, );

    /*  ******END*******************/
    const didRequestSucceed = bbStandardRequestHandler(request, standardName, false, true, false,);

    // const didRequestSucceed = bbDeviantRequestHandler(request, standardName, true, true, false, true);

    if (didRequestSucceed) {
        yield put(fetchCloudIntegrationDataSuccess(
            {
                entityId,
                integrationId,
                queryType,
                integrationDescription,
                inboundData: request.data,
            }));
    } else {
        yield put(fetchCloudIntegrationDataFail({
            entityId,
            integrationId,
            queryType,
            request: request.data,
        }));
    }

    console.groupEnd();
}

export function* watchEveryGetCloudIntegrationDataGenerator() {
    yield takeEvery(FETCH_CLOUD_INTEGRATION_DATA, getCloudIntegrationDataGenerator);
}

/* ***************************
CLOUD INTEGRATIONS: fetching files for storage buckets
*************************** */

const getCloudIntegrationFilesRequest = async (entityId, integrationId, storageName) =>
    await  apiClient.get(`/integration/action?id=${integrationId && integrationId}&query=files&params=${storageName}`, {timeout: 35000}
    )
        .then(data => data)
        .catch(error => error);

function* getCloudIntegrationFilesGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const {entityId, integrationId, storageName } = payload;
    const standardName = `fetchCloudIntegrationFiles`;     console.group(`${standardName} Generator...: `);
    const request = yield call(getCloudIntegrationFilesRequest, entityId, integrationId, storageName);

    /*  ******END*******************/
    const didRequestSucceed = bbStandardRequestHandler(request, standardName, false, true, false,);

    // const didRequestSucceed = bbDeviantRequestHandler(request, standardName, true, true, false, true);

    if (didRequestSucceed) {
        yield put(fetchCloudIntegrationFilesSuccess(
            {
                entityId,
                integrationId,
                storageName,
                inboundData: request.data,
            }));
    } else {
        yield put(fetchCloudIntegrationFilesFail({
            entityId,
            integrationId,
            storageName,
            request: request.data,
        }));
    }

    console.groupEnd();
}

export function* watchEveryGetCloudIntegrationFilesGenerator() {
    yield takeEvery(FETCH_CLOUD_INTEGRATION_FILES, getCloudIntegrationFilesGenerator);
}
/* ***************************
   Fetching a detailed target object
   *************************** */

const getTargetDetailsRequest = async (targetId) =>
    await  apiClient.get(`/risk/target?target=${targetId}`, {timeout: 100000}
    )
        .then(data => data)
        .catch(error => error);

function* getTargetDetailsGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "fetchTargetDetails";     console.group(`${standardName} Generator...: `);
    const {targetId, entityId, customerId} = payload;
    const request = yield call(getTargetDetailsRequest, targetId);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, false, true);

    if (didRequestSucceed) {
        yield put(fetchTargetDetailsSuccess(
            {
                targetId,
                entityId: entityId,
                customerId: customerId,
                inboundData: request.data,
            }));
    } else {
        yield put(fetchTargetDetailsFail({
            targetId,
            // entityId: entityId,
            request: request.data,
        }));
    }

    console.groupEnd();
}

export function* watchLeadingGetTargetDetailsGenerator() {
    yield takeLeading(FETCH_TARGET_DETAILS, getTargetDetailsGenerator);
}


/* ***************************
   Fetching a risk cycle social information
   *************************** */

const getCycleSocialRequest = async (cycleId, pageNum) =>
    await  apiClient.get(`/risk/cycle/social?cycle=${cycleId}${pageNum && `&page=${pageNum}`}`, {timeout: 100000}
    )
        .then(data => data)
        .catch(error => error);

function* getCycleSocialGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "fetchCycleSocial";     console.group(`${standardName} Generator...: `);
    const {cycleId, customerId, entityId, pageNum = null} = payload;
    const request = yield call(getCycleSocialRequest, cycleId, pageNum, entityId);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, false, true);

    if (didRequestSucceed) {
        yield put(fetchCycleSocialSuccess(
            {
                customerId: customerId,
                cycleId: cycleId,
                entityId: entityId,
                pageNumberFetched: pageNum,
                inboundData: request.data,
            }));
    } else {
        yield put(fetchCycleSocialFail({
            cycleId: cycleId,
            request: request.data,
        }));
    }

    console.groupEnd();
}

export function* watchLeadingGetCycleSocialGenerator() {
    yield takeLeading(FETCH_CYCLE_SOCIAL, getCycleSocialGenerator);
}

/* ***************************
   Fetching a detailed identity object
   *************************** */

const getIdentityDetailsRequest = async (identityId) =>
    await  apiClient.get(`/risk/identity?tested_identity=${identityId}`, {timeout: 100000}
    )
        .then(data => data)
        .catch(error => error);

function* getIdentityDetailsGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "fetchIdentityDetails";     console.group(`${standardName} Generator...: `);
    const {identityId, entityId, cycleId, customerId} = payload;
    const request = yield call(getIdentityDetailsRequest, identityId);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, false, true);

    if (didRequestSucceed) {
        yield put(fetchIdentityDetailsSuccess(
            {
                identityId,
                entityId,
                cycleId,
                customerId,
                inboundData: request.data,
            }));
    } else {
        yield put(fetchIdentityDetailsFail({
            identityId,
            // entityId: entityId,
            request: request.data,
        }));
    }

    console.groupEnd();
}

export function* watchLeadingGetIdentityDetailsGenerator() {
    yield takeLeading(FETCH_IDENTITY_DETAILS, getIdentityDetailsGenerator);
}

/* ***************************
   Updating attacks authorized for BR Business customers
   *************************** */

const putBRSocialTestsAuthorizedRequest = async (entityId, newAuthorizeStatus) =>
    await  apiClient.put(`/risk/entity/authorize`,{
            entity: entityId,
            social: newAuthorizeStatus
        },{timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* putBRSocialTestsAuthorizedGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "updateBRSocialTestsAuthorized";     console.group(`${standardName} Generator...: `);
    const {customerId, entityId, newAuthorizeStatus} = payload;
    const request = yield call(putBRSocialTestsAuthorizedRequest, entityId, newAuthorizeStatus);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true);

    if (didRequestSucceed) {
        yield put(updateBRSocialTestsAuthorizedSuccess(
            {
                customerId: customerId,
                entityId: entityId,
                inboundData: request.data,
            }));
    } else {
        yield put(updateBRSocialTestsAuthorizedFail({
            entityId: entityId,
            request: request.data,
        }));
    }

    console.groupEnd();
}

export function* watchLeadingPutBRSocialTestsAuthorizedGenerator() {
    yield takeLeading(UPDATE_BR_SOCIAL_TESTS_AUTHORIZED, putBRSocialTestsAuthorizedGenerator);
}

/* ***************************
   Adding an Identity Provided
   *************************** */

const postBRIdentityProvidedRequest = async (entityId, email, first, last) =>
    await  apiClient.post(`/risk/identity/provided`,{
            entity: entityId,
            email: email,
            first: first ? first : null,
            last: last ? last : null,
        },{timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* postBRIdentityProvidedGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "addBRIdentityProvided";     console.group(`${standardName} Generator...: `);
    const {customerId, entityId, email, first, last} = payload;
    const request = yield call(postBRIdentityProvidedRequest, entityId, email, first, last);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true);

    if (didRequestSucceed) {
        yield put(addBRIdentityProvidedSuccess(
            {
                customerId: customerId,
                entityId: entityId,
                inboundData: request.data,
            }));
    } else {
        yield put(addBRIdentityProvidedFail({
            entityId: entityId,
            request: request.data,
        }));
    }

    console.groupEnd();
}

export function* watchLeadingPostBRIdentityProvidedGenerator() {
    yield takeLeading(ADD_BR_IDENTITY_PROVIDED, postBRIdentityProvidedGenerator);
}
/* ***************************
   Updating Identity Provided
   *************************** */

const putBRIdentityProvidedRequest = async (identityId, newIsActiveStatus) =>
    await  apiClient.put(`/risk/identity/provided`,{
            id: identityId,
            is_active: newIsActiveStatus,
        },{timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* putBRIdentityProvidedGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "updateBRIdentityProvided";     console.group(`${standardName} Generator...: `);
    const {customerId, entityId, identityId, newIsActiveStatus} = payload;
    const request = yield call(putBRIdentityProvidedRequest, identityId, newIsActiveStatus);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true);

    if (didRequestSucceed) {
        yield put(updateBRIdentityProvidedSuccess(
            {
                customerId: customerId,
                entityId: entityId,
                inboundData: request.data,
            }));
    } else {
        yield put(updateBRIdentityProvidedFail({
            entityId: entityId,
            request: request.data,
        }));
    }

    console.groupEnd();
}

export function* watchLeadingPutBRIdentityProvidedGenerator() {
    yield takeLeading(UPDATE_BR_IDENTITY_PROVIDED, putBRIdentityProvidedGenerator);
}


/* ***************************
   Fetching a vector's testing results
   *************************** */

const getVectorResultsRequest = async (entityId, customerId, cycleId, vectorId) =>
    await  apiClient.get(`/risk/vector?id=${vectorId}&external=1`, {timeout: 100000}
    )
        .then(data => data)
        .catch(error => error);

function* getVectorResultsGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "fetchVectorResults";     console.group(`${standardName} Generator...: `);
    const {entityId, customerId, cycleId ,vectorId} = payload;
    const request = yield call(getVectorResultsRequest, entityId, customerId, cycleId, vectorId);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, false, true);

    if (didRequestSucceed) {
        yield put(fetchVectorResultsSuccess(
            {
                customerId: customerId,
                entityId: entityId,
                cycleId: cycleId,
                vectorId: vectorId,
                inboundData: request.data,
            }));
    } else {
        yield put(fetchVectorResultsFail({
            vectorId: vectorId,
            request: request.data,
        }));
    }

    console.groupEnd();
}

export function* watchEveryGetVectorResultsGenerator() {
    yield takeEvery(FETCH_VECTOR_RESULTS, getVectorResultsGenerator);
}
/*  jfd**********22.Nov.29.00:03*****
 *   Subportfolio Sagas
     ********************** `--===<>==<>==C>-< */

/* ***************************
   Creating/adding a new subportfolio
   *************************** */

const postAddSubportfolioRequest = async (customerId, name, description) =>
    await  apiClient.post(`/risk/portfolio`,{
            customer: customerId,
            name: name,
            description: description ? description : null,
            type: "portfolio", //per the API guide, this parameter must be "portfolio" to create a sub portfolio.
        },{timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* postAddSubportfolioGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "addSubportfolio";     console.group(`${standardName} Generator...: `);
    const {customerId, name, description} = payload;
    console.log("addSubportfolio got this", "customerId", customerId, "name", name,  "description", description, "payload", payload)
    const request = yield call(postAddSubportfolioRequest, customerId, name, description);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true);

    if (didRequestSucceed) {
        yield put(addSubportfolioSuccess(
            {
                customerId: customerId,
                name: name,
                inboundData: request.data,
            }));
    } else {
        yield put(addSubportfolioFail({
            customerId: customerId,
            request: request.data,
        }));
    }

    console.groupEnd();
}

export function* watchLeadingPostAddSubportfolioGenerator() {
    yield takeLeading(ADD_BR_SUBPORTFOLIO, postAddSubportfolioGenerator);
}

/* ***************************
   Updating Modifying a new subportfolio
   *************************** */

const putUpdateSubportfolioRequest = async (subportfolioId, name, description) =>
    await  apiClient.put(`/risk/portfolio`,{
            portfolio: subportfolioId,
            name: name ? name : null,
            description: description ? description : null,
        },{timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* putUpdateSubportfolioGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "updateSubportfolio";     console.group(`${standardName} Generator...: `);
    const {subportfolioId, name, description} = payload;
    // console.log("updateSubportfolio got this", "subportfolioId", subportfolioId, "name", name,  "description", description, "payload", payload)
    const request = yield call(putUpdateSubportfolioRequest, subportfolioId, name, description);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true);

    if (didRequestSucceed) {
        yield put(updateSubportfolioSuccess(
            {
                subportfolioId,
                name: name,
                inboundData: request.data,
            }));
    } else {
        yield put(updateSubportfolioFail({
            subportfolioId,
            request: request.data,
        }));
    }

    console.groupEnd();
}

export function* watchLeadingPostUpdateSubportfolioGenerator() {
    yield takeLeading(UPDATE_BR_SUBPORTFOLIO, putUpdateSubportfolioGenerator);
}

/* ***************************
   Deleting a subportfolio
   *************************** */

const deleteSubportfolioRequest = async (customerId, subportfolioId) =>
    await  apiClient.delete(`/risk/portfolio`,
        { data: {
                customer: customerId,
                portfolio: subportfolioId
            }
        },{timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* deleteSubportfolioGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "deleteSubportfolio";     console.group(`${standardName} Generator...: `);
    const {customerId, subportfolioId} = payload;
    const request = yield call(deleteSubportfolioRequest, customerId, subportfolioId);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true);

    if (didRequestSucceed) {
        yield put(deleteSubportfolioSuccess (
            {
                customerId: customerId,
                subportfolioId,
                inboundData: request.data,
            }));
    } else {
        yield put(deleteSubportfolioFail({
            customerId: customerId,
            subportfolioId,
            request: request.data,
        }));
    }

    console.groupEnd();
}

export function* watchLeadingDeleteSubportfolioGenerator() {
    yield takeLeading(DELETE_BR_SUBPORTFOLIO, deleteSubportfolioGenerator);
}

/* ***************************
   Adding a new entity while at the same time adding it to a subportfolio
   *************************** */

const addPortfolioEntityAndAddToSubportfolioRequest = async (customerId,
                                                             newEntityName,
                                                             newEntityWebsite,
                                                             subportfolioId) =>
    await  apiClient.post(`/risk/portfolio`,{
            customer: customerId,
            name: newEntityName,
            website: newEntityWebsite,
            portfolio: subportfolioId ? subportfolioId : null
        },{timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* addPortfolioEntityAndAddToSubportfolioGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "addPortfolioEntityAndAddToSubportfolio";     console.group(`${standardName} Generator...: `);
    const {
        customerId,
        newEntityName,
        newEntityWebsite,
        subportfolioId
    } = payload;
    const request = yield call(addPortfolioEntityAndAddToSubportfolioRequest,
        customerId,
        newEntityName,
        newEntityWebsite,
        subportfolioId);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true);

    if (didRequestSucceed) {
        yield put(addBRPortfolioEntityAndAddToSubportfolioSuccess(
            {
                customerId: customerId,
                subportfolioId,
                inboundData: request.data,
            }));
    } else {
        yield put(addBRPortfolioEntityAndAddToSubportfolioFail({
            customerId: customerId,
            subportfolioId,
            request: request.data,
        }));
    }

    console.groupEnd();
}

export function* watchLeadingAddPortfolioEntityAndAddToSubportfolioGenerator() {
    yield takeLeading(ADD_BR_NEW_ENTITY_TO_SUBPORTFOLIO, addPortfolioEntityAndAddToSubportfolioGenerator);
}

/* ***************************
   Update entity name for entity in a portfolio (staff call only)
   *************************** */

const updateEntityNameRequest = async (customerId,entityId, updatedName) =>
    await  apiClient.put(`/risk/entity`,{
            id: entityId,
            name: updatedName
        }, {timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* updateEntityNameGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "updateEntityName";     console.group(`${standardName} Generator...: `);
    const {customerId, entityId, updatedName} = payload;
    const request = yield call(updateEntityNameRequest, customerId, entityId, updatedName);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, true);

    if (didRequestSucceed) {
        yield put(updateEntityNameSuccess({
            customerId,
            entityId,
            updatedName,
            inboundData: request.data,
        }));
    } else {
        yield put(updateEntityNameFail({
            customerId,
            entityId,
            updatedName,
            request: request.data,
        }));
    }

    console.groupEnd();
}
export function* watchLeadingUpdateEntityNameGenerator() {
    yield takeLeading(UPDATE_ENTITY_NAME, updateEntityNameGenerator);
}



/* ***************************
   root Saga
   *************************** */

export default function* rootSaga() {
    yield all([
        fork(watchLeadingGetRiskPortfolioGenerator),
        fork(watchLeadingGetRiskCycleReportGenerator),
        fork(watchLeadingGetRiskCycleDetailsGenerator),
        fork(watchLeadingGetBRBusinessSharesGenerator),
        fork(watchLeadingPostBRBusinessShareGenerator),
        fork(watchEveryPutBRBusinessShareGenerator),
        fork(watchLeadingPostBRPortfolioEntityGenerator),
        fork(watchLeadingDeleteBRPortfolioEntityGenerator),
        fork(watchLeadingPostBRPortfolioReportRequestGenerator),
        fork(watchLeadingPutBRAttacksAuthorizedGenerator),
        fork(watchLeadingPostBRDomainProvidedGenerator),
        fork(watchLeadingPutBRDomainProvidedGenerator),
        fork(watchLeadingPostBRTargetIpProvidedGenerator),
        fork(watchLeadingPutBRTargetIpProvidedGenerator),
        fork(watchLeadingPostBRSubdomainProvidedGenerator),
        fork(watchLeadingPutBRSubdomainProvidedGenerator),
        fork(watchLeadingPostBRValidationGenerator),
        fork(watchLeadingGetRiskCycleTargetsGenerator),
        fork(watchLeadingGetRiskCycleGenerator),
        fork(watchLeadingGetCloudIntegrationOptionsGenerator),
        fork(watchLeadingGetCloudIntegrationRegistrationGenerator),
        fork(watchLeadingGetCloudIntegrationUnregistrationGenerator),
        fork(watchLeadingGetTargetDetailsGenerator),
        fork(watchLeadingGetCycleSocialGenerator),
        fork(watchLeadingGetIdentityDetailsGenerator),
        fork(watchLeadingPutBRSocialTestsAuthorizedGenerator),
        fork(watchLeadingPostBRIdentityProvidedGenerator),
        fork(watchLeadingPutBRIdentityProvidedGenerator),
        fork(watchEveryGetCloudIntegrationDataGenerator),
        fork(watchEveryGetCloudIntegrationFilesGenerator),
        fork(watchEveryGetVectorResultsGenerator),
        fork(watchLeadingPostAddSubportfolioGenerator),
        fork(watchLeadingDeleteSubportfolioGenerator),
        fork(watchLeadingAddPortfolioEntityAndAddToSubportfolioGenerator),
        fork(watchLeadingPostUpdateSubportfolioGenerator),
        fork(watchLeadingUpdateEntityNameGenerator),
    ]);
}